var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center"},[(_vm.currentUserReacted)?[_c('oz-icon',{class:_vm.isPadletColorSchemeDark ? 'text-canary-500' : 'text-grape-500',attrs:{"size":16,"name":"heart_filled","role":"button"},on:{"click":_vm.removeReaction}}),_vm._v(" "),_c('span',{class:[
        'ml-0.5',
        'text-12-15',
        'font-sans',
        _vm.isPadletColorSchemeDark ? 'text-light-text-200' : 'text-dark-text-200' ]},[_vm._v(_vm._s(_vm.reactionCount))])]:[_c('oz-icon',{class:_vm.isPadletColorSchemeDark ? 'text-light-text-300' : 'text-dark-text-300',attrs:{"size":16,"name":"heart_outline","role":"button"},on:{"click":_vm.like}}),_vm._v(" "),_c('span',{class:[
        'ml-0.5',
        'text-12-15',
        'font-sans',
        _vm.isPadletColorSchemeDark ? 'text-light-text-300' : 'text-dark-text-300' ]},[_vm._v(_vm._s(_vm.reactionCount))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }